import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { VehicleListModel } from 'src/app/models/vehicles/vehicleListModel';
import { SubPlanAssociationUserBadgeModel } from 'src/app/modules/customer-accounts/pages/sub-plan-associations/models/subPlanAssociationUserBadgeModel';
import { IconType } from 'src/app/tinea-components/icon/enum/icon-type';
import { BaseTableMapper } from 'src/app/tinea-components/table/mapper/BaseTableMapper';
import { TableModel } from 'src/app/tinea-components/table/models/input/table-model';
import { TableRows } from 'src/app/tinea-components/table/models/input/table-rows';
import { TableTd } from 'src/app/tinea-components/table/models/input/table-td';
import { TableTh } from 'src/app/tinea-components/table/models/input/table-th';
import { ValueCell } from 'src/app/tinea-components/table/models/input/value-cell';

@Injectable({
    providedIn: 'root'
  })
export class TableSubPlanAssociationBadgesMapper extends BaseTableMapper  {

    // -- configuration
    readonly CSS_CLASS_CONFIG = 'table-subplan-association-badges';

    readonly DISPLAY_NO_DATA = '--';

    //
    readonly COLUMN_ID_VALUE = 'VALUE';
    readonly COLUMN_ID_PLAN = 'PLAN';
    readonly COLUMN_ID_ACTION = 'ACTION';

    readonly CELL_ID_DELETE_BADGE = 'CELL_ID_DELETE_BADGE';

    // css
    readonly CSS_UNASSIGN_BTN = 'btn-action btn-action-alert';
    readonly CSS_NO_DATA = 'no-data';

    table: TableModel;

    constructor(private translate: TranslateService) {
        super();
        this.table = new TableModel();
    }

    init(badgelist: SubPlanAssociationUserBadgeModel[]): TableModel {
        this.table = new TableModel();
        // configuration
        this.initConfiguration();
        // header
        this.initHeader();
        // data
        this.initDataRow(badgelist);

        return this.table;
    }

    initConfiguration(): void {
        this.table.configuration.cssClass = this.CSS_CLASS_CONFIG;
        this.table.configuration.noDataRowMsg = this.translate.instant('error.no_result');
    }

    initHeader(): void {
        const thValue = this.createSimpleTh(this.COLUMN_ID_VALUE, this.translate.instant('component.subPlanAssociations.tableBadges.value'));
        const thAction = this.createSimpleTh(this.COLUMN_ID_ACTION, this.translate.instant('tables.action'));

        const thList = [thValue, thAction];
        this.setHeaderCells(thList);
    }

    initDataRow(badgeList: SubPlanAssociationUserBadgeModel[]): void {

        badgeList.forEach(badge => {
            const tableRows = new TableRows(badge);

            const value = this.createSimpleTd(this.COLUMN_ID_VALUE, badge.name || this.DISPLAY_NO_DATA);

            // td - action
            const action = new TableTd();
            // btn remove
            const actionRemoveCell = new ValueCell();
            actionRemoveCell.displayedValue = this.translate.instant('component.subPlanAssociations.tableBadges.delete');
            actionRemoveCell.valueCssClass = this.CSS_UNASSIGN_BTN;
            actionRemoveCell.dataId = this.CELL_ID_DELETE_BADGE;
            actionRemoveCell.tagType = 'button';
            // actionRemoveCell.cssClass = 'table-action-blue';

            action.valueCells.push(actionRemoveCell);


            // add cells
            // ================>
            tableRows.cells = [value, action];

            // push row
            // ================>
            this.table.dataRow.push(tableRows);
        });
    }

    setHeaderCells(thList: TableTh[]): void {
        this.table.header.cells = thList;
    }
}
